import type { AnnualConst, OptionsData } from "../algorithm.types";

export default function annualConstFn(
  optionsData: Pick<OptionsData, "noOfTechs" | "noOfDayTypes">,
): AnnualConst {
  return {
    annualTechGen: Array(optionsData.noOfTechs).fill(0),
    annualTechCost: Array(optionsData.noOfTechs).fill(0),
    totalAnnualCostOriginalPercent: 100,
    totalAnnualCostIncreasePercent: 0,
    totalAnnualCarbonOriginalPercent: 0,
    totalAnnualCarbonIncreasePercent: 0,
    annualTechCarbon: Array(optionsData.noOfTechs).fill(0),
    averageDemandPerDay: Array(optionsData.noOfDayTypes).fill(0), // used to calculate annual demand
    averageGenPerDay: [],
  };
}
